import React from "react"

function IconUserSwitch({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="user-switch"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-user-switch"
      {...props}
    >
      <path
        d="M9.378 2.388c2.586 0 4.682 2.038 4.682 4.553v2.743a4.47 4.47 0 0 1-1.293 3.141l2.26.649a2.182 2.182 0 0 1 1.58 2.097v2.871a2.182 2.182 0 0 1-2.183 2.182H4.364a2.182 2.182 0 0 1-2.182-2.182v-2.867c0-.975.647-1.832 1.585-2.098l2.238-.636a4.472 4.472 0 0 1-1.31-3.157V6.941c0-2.515 2.097-4.553 4.683-4.553zm2.016 11.406a4.764 4.764 0 0 1-1.782.437l-.234.005c-.71 0-1.384-.153-1.987-.429l-3.266.929a.873.873 0 0 0-.626.724l-.008.115v2.867c0 .445.333.812.763.866l.11.007h10.06a.873.873 0 0 0 .866-.763l.007-.11v-2.871a.873.873 0 0 0-.512-.795l-.12-.044-3.27-.938zm6.29-5.416a.655.655 0 0 1 .744 0l.09.076.076.09a.655.655 0 0 1 0 .745l-.076.09-.766.765h4.164l.107.01a.655.655 0 0 1 0 1.291l-.107.009h-4.164l.766.765.076.09a.655.655 0 0 1-.91.911l-.091-.076-1.883-1.882-.076-.09a.655.655 0 0 1 0-.745l.076-.09 1.883-1.883.09-.076zM9.377 3.697c-1.804 0-3.265 1.358-3.367 3.054l-.006.19v2.743c0 1.72 1.397 3.139 3.146 3.238l.196.006.202-.005c1.73-.082 3.097-1.412 3.196-3.049l.006-.19V6.941c0-1.784-1.502-3.244-3.373-3.244zm11.012-.773.09.075 1.883 1.883c.227.227.252.58.075.835l-.075.09L20.48 7.69a.655.655 0 0 1-1.001-.835l.076-.09.763-.766h-4.162a.655.655 0 0 1-.106-1.3l.106-.009h4.162l-.763-.765a.655.655 0 0 1-.076-.835l.076-.09a.655.655 0 0 1 .835-.076z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconUserSwitch
